import { useEffect } from "react";

export function useQueryPollingWhile(
  shouldPoll: boolean,
  startPolling: (pollInterval: number) => void,
  stopPolling: () => void,
  pollIntervalMs: number
) {
  useEffect(() => {
    if (!shouldPoll) {
      stopPolling();
      return;
    }

    startPolling(pollIntervalMs);
    return () => stopPolling();
  }, [shouldPoll, startPolling, stopPolling, pollIntervalMs]);
}
